import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import FileForm from './tcfile-form-view';
import Workflow from '../workflow/workflow';
import config from 'react-global-configuration';
import { Tab, Row, Col, Nav, NavItem, Glyphicon } from 'react-bootstrap';
import AgentBrokeragePrefs from '../shared/agent-brokerage-prefs';

@inject('appStore')
@observer
export default class FileDetailView extends Component {
    constructor(props) {
        super(props);
        this.props.appStore.tcFileStore.hasErrors = false;
    }

    handleNavTrack(selectedTab) {
        // appStore.analytics.track("File Detail Nav Selected", {target: selectedTab})
    }

    render() {
        return (
            <div className="tab-pane active">
                <Tab.Container id="fileInternalNav" defaultActiveKey="details">
                    <Row className="vert-tab-wrapper">
                        <Col sm={1} className="tabs-left">
                            <Nav bsStyle="tabs" stacked onSelect={this.handleNavTrack}>
                                <NavItem eventKey="details">
                                    <Glyphicon glyph="edit" />
                                    </NavItem>
                                {this.props.appStore.tcFileStore.hasErrors
                                ? <div></div>
                                : 
                                <NavItem eventKey="workflow">
                                    <Glyphicon glyph="list" />
                                </NavItem>
                            }
                            </Nav>
                        </Col>
                        <Col sm={11}>
                            <Row>
                                <Col sm={7} style={{ borderRight: '1px solid #ddd' }}>
                                    <Tab.Content animation mountOnEnter={true}>
                                        <Tab.Pane eventKey="details">
                                            <div className="row detail-view">
                                                {appStore.tcFileStore.selectedFile ? <FileForm /> : null}
                                            </div>
                                        </Tab.Pane>
                                        <Tab.Pane eventKey="workflow">
                                            {config.get('FEATURE_WORKFLOW_ENABLED') === 'true' &&
                                            appStore.tcFileStore.selectedFile &&
                                            appStore.workflowStore.isStateLoaded ? (
                                                <Workflow />
                                            ) : null}
                                        </Tab.Pane>
                                    </Tab.Content>
                                </Col>
                                <Col sm={5}>
                                    {appStore.tcFileStore.selectedFile &&
                                    appStore.tcFileStore.selectedFile.agents.length ? (
                                        <AgentBrokeragePrefs />
                                    ) : null}
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </Tab.Container>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/files/tcfile-detail-view.js